import { SidebarNavRowStatusIcon } from '@/app-shell/layout/Navigation/sidebar/sidebar-nav-row-status';
import { cn } from '@/lib/cn';

import styles from './work-sidebar-approval-hand.module.css';

/**
 * Work-sidebar status slot. A pending approval waves the hand here only;
 * the shared icon stays still for the old chat sidebar.
 */
export function WorkSidebarApprovalHand({ needsAttention }: { needsAttention: boolean }) {
  return (
    <span
      className={cn('contents', needsAttention && styles.approvalHand)}
      data-approval-hand={needsAttention ? 'true' : undefined}
    >
      <SidebarNavRowStatusIcon status={needsAttention ? 'needs-attention' : 'rest'} />
    </span>
  );
}
